<i class="ml-2 fa fa-star-o" style="vertical-align: -1px;"></i>
